import { addLicenseType } from "../../../../../actions/Utilities/LicenseType";
import { useMutation, useQueryClient } from "react-query";
import { LicenseTypeInfo } from "../types";
import { toast } from "../../../../../components/toastNotification";

const useAddLicenseType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    
    (newData: LicenseTypeInfo) =>
      addLicenseType(newData),
    {
      onSuccess: (res: any) => {
        if (res === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetLicenseType"]);
          toast.fire("Success", "License Type Added Successfully", "success");
        }
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to Add License Type", "error");
      },
    }
  );

  return mutate;
};
export default useAddLicenseType;
